import { Component, Input } from '@angular/core';
import { FooterMenuItem } from '~components/footer-menu-item/footer-menu-item.component';

@Component({
  selector: 'footer-menu',
  templateUrl: './footer-menu.component.html',
  styleUrls: ['./footer-menu.component.scss'],
  standalone: false,
})
export class FooterMenuComponent {
  @Input()
  public readonly menuItems: FooterMenuItem[];

  constructor() {}
}
